<template>
  <div :id="anchor" :class="[{'simulation-page-form': !noScroll}, {'simulation-page-form-no-scroll': noScroll}]">
    <div class="simulation-page-container">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'form-step',
  props: {
    anchor: {
      type: String,
      default: ''
    },
    noScroll: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss">

@import "~bootstrap/scss/functions";
@import '~bootstrap/scss/variables';

.simulation-page-form, .simulation-page-form-no-scroll{
  position: relative;
  height: 100vh;
  overflow-y: auto;
  overflow-x: visible;
  width: 100vw;
  // justify-content: center;
  // align-items: center;
  -webkit-overflow-scrolling: touch;

  .simulation-page-container {
    width: 100%;
    padding-top: 15vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    @media screen and (max-width: map-get($grid-breakpoints, md)){
      padding-top: 100px;
    }
    @media screen and (max-width: map-get($grid-breakpoints, sm)){
      padding-top: 5em;
      padding-bottom: 4em;
    }
  }
}
</style>
